const state = {
	selectedApplicants: [],
	isCollapsed: false,
	searchQuery: '',
	aisSearchQuery: '',
}


const mutations = {
	SET_SELECTED_APPLICANTS(state, value){
		state.selectedApplicants = value
	},
	SET_START_COLLATION(state, value){
		state.startCollation = value
	},
	SET_SEARCH_QUERY(state, value){
		state.searchQuery = value
	},
	SET_CARD_COLLAPSE_STATE(state, value){
		state.isCollapsed = value
	},
	SET_SEARCH_ENGINE_DETAILS(state, value){
		state.searchEngineDetails = value
	},
	SET_AIS_SEARCH_QUERY(state, value){
		state.aisSearchQuery = value
	},
}

const actions = {
	setAisSearchQuery ({ commit }, text) {
	    commit('SET_AIS_SEARCH_QUERY', text)
	}
}

const ApplicantTrackingSystem = {
	state,
	mutations,
	actions,
}

export default ApplicantTrackingSystem
